import React from 'react';
import settings from '../../../configs/appSettings';
import '../_style.scss';
import Doc from '../DocTitle';
import 'bulma';
import {imageCdnUrls} from "../ImageCdnUrls";

const InternalServerErrorPage = () => {
    return (
        <div className="error-page">
            <div className="message">
                <p className="big-font">500</p>
                <p className="invalid buffer">Internal Server Error.</p>
                <p>If you continue to receive this error, please contact customer support at</p>
                <p><a className="blue-link"
                      href={"mailto:" + settings.supportInfo.email}>{settings.supportInfo.email}</a> or <a
                    className="blue-link" href={"tel:" + settings.supportInfo.phone}>{settings.supportInfo.phone}.</a>
                </p>
                <div className="logo">
                    <img src={imageCdnUrls.nLogoGrey} width="40" height="40"/>
                </div>
            </div>
            <Doc syncTo="Internal Server Error"/>
        </div>
    );
};

export default InternalServerErrorPage;
